import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const WaselAdminPreset = definePreset(Aura, {
  primitive: {
    wasel: {
      50: '#eef4fa',
      100: '#d9e6f2',
      200: '#b4cde4',
      300: '#8eb2d4',
      400: '#5d8bb5',
      500: '#244D75',
      600: '#1f4266',
      700: '#17385a',
      800: '#142f4b',
      900: '#10263d',
      950: '#0a1928',
    },
  },
  semantic: {
    primary: {
      50: '{wasel.50}',
      100: '{wasel.100}',
      200: '{wasel.200}',
      300: '{wasel.300}',
      400: '{wasel.400}',
      500: '{wasel.500}',
      600: '{wasel.600}',
      700: '{wasel.700}',
      800: '{wasel.800}',
      900: '{wasel.900}',
      950: '{wasel.950}',
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '#00a3a3',
      offset: '2px',
    },
    sidebar: {
      background: '#17385a',
      border: '#1f4266',
      text: '#d9e6f2',
      mutedText: '#b4cde4',
      activeText: '#ffffff',
      accent: '#00a3a3',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f7f9fb',
          100: '#f1f4f7',
          200: '#e3e8ee',
          300: '#d5dce4',
          400: '#93a1b0',
          500: '#5b6b7e',
          600: '#4a5a6d',
          700: '#334155',
          800: '#1e293b',
          900: '#0f1b2a',
          950: '#070e17',
        },
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.200}, {surface.0} 12%)',
          focusBackground: 'color-mix(in srgb, {primary.300}, {surface.0} 10%)',
          color: '{primary.800}',
          focusColor: '{primary.950}',
        },
        text: {
          color: '#0f1b2a',
          hoverColor: '#17385a',
          mutedColor: '#5b6b7e',
          hoverMutedColor: '#4a5a6d',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f3f7fa',
          100: '#e6edf3',
          200: '#c9d3dc',
          300: '#a9b6c3',
          400: '#93a1b0',
          500: '#5a6878',
          600: '#364352',
          700: '#2a3440',
          800: '#1b232c',
          900: '#161d24',
          950: '#0e1318',
        },
        primary: {
          color: '#7ab6e8',
          contrastColor: '{surface.950}',
          hoverColor: '{primary.200}',
          activeColor: '{primary.100}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 62%)',
          focusBackground: 'color-mix(in srgb, {primary.300}, transparent 54%)',
          color: '{surface.0}',
          focusColor: '{surface.0}',
        },
        text: {
          color: '#e6edf3',
          hoverColor: '#ffffff',
          mutedColor: '#93a1b0',
          hoverMutedColor: '#c9d3dc',
        },
      },
    },
  },
});

export default WaselAdminPreset;

